import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useIsPro } from 'hooks/useIsPro';
import cn from 'classnames';

import logoutIcon from 'assets/logout.svg';
import settingsIcon from 'assets/settings.svg';

import { ROUTES } from 'routes/route.constants';

import { logoutUser } from 'utlis/globalFunctions';

import styles from './styles.module.scss';

const SidebarMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reviewData = useSelector(state => state.designReview.reviewCount);
  const isPro = useIsPro();

  const handleLogout = () => {
    localStorage.removeItem('userObject');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('authenticated');

    logoutUser(dispatch, navigate);
    navigate(ROUTES.TEAM_LOGIN);
  };

  const handleSettings = () => {
    navigate(ROUTES.TEAM_SETTINGS);
  };

  const reviewsRemaining = reviewData?.reviews_remaining || 0;
  // Set total credits based on user tier: 60 for pro, 20 for free
  const totalCredits = isPro ? 60 : 20;
  const creditPercentage = totalCredits > 0 ? (reviewsRemaining / totalCredits) * 100 : 0;

  return (
    <div className={styles['contextual-menu']}>
      {/* Progress Bar Section */}
      <div className={styles['progress-bar-section']}>
        {/* Labels */}
        <div className={styles['progress-labels']}>
          {/* Credits available */}
          <div className={styles['credits-available']}>
            <span
              className={cn(styles['credits-used'], {
                [styles['credits-zero']]: reviewsRemaining === 0,
              })}
            >
              {reviewsRemaining}
            </span>
            <span className={styles['credits-total']}>
              /
              {' '}
              {totalCredits}
              {' '}
              credits
            </span>
          </div>

          {/* Percentage */}
          <span className={styles['credits-percentage']}>
            {Math.round(creditPercentage)}
            %
          </span>
        </div>

        {/* Progress Bar */}
        <div className={styles['progress-bar']}>
          {/* Background Bar */}
          <div className={styles['progress-bar-background']} />
          {/* Progress Bar */}
          <div
            className={cn(styles['progress-bar-fill'], {
              [styles.hidden]: creditPercentage <= 0,
            })}
            style={{ right: `${100 - Math.min(100, creditPercentage)}%` }}
          />
        </div>
      </div>

      {/* Divider */}
      <div className={styles.divider} />

      {/* Settings Nav Link */}
      <button
        onClick={handleSettings}
        className={cn(styles['nav-link'], styles.settings)}
      >
        <img
          src={settingsIcon}
          alt="Settings"
          className={styles['nav-link-icon']}
        />
        <span className={styles['nav-link-text']}>
          Settings
        </span>
      </button>

      {/* Log out Nav Link */}
      <button
        onClick={handleLogout}
        className={cn(styles['nav-link'], styles.logout)}
      >
        <img
          src={logoutIcon}
          alt="Log out"
          className={styles['nav-link-icon']}
        />
        <span className={styles['nav-link-text']}>
          Log out
        </span>
      </button>
    </div>

  );
};

export default SidebarMenu;
